'use client'

import { Home } from 'react-feather'
import { AchieveLink } from 'components/AchieveLink'

function BreadcrumbHomeLink({ track, ...rest }) {
  return (
    <AchieveLink underline="hover" color="inherit" track={track} {...rest} href="/">
      <Home size={14} aria-hidden="true" focusable="false" />
      <span className="sr-only">Home</span>
    </AchieveLink>
  )
}

export { BreadcrumbHomeLink }
